import React from 'react';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6">
        <div className="flex items-center mb-4">
          <div className="w-12 h-12 bg-red-100 dark:bg-red-900 rounded-lg flex items-center justify-center mr-4">
            <span className="text-2xl">🪱💥</span>
          </div>
          <div>
            <h1 className="text-xl font-semibold text-gray-900 dark:text-white">
              WormTracker столкнулся с проблемой
            </h1>
            <p className="text-gray-600 dark:text-gray-300">
              Произошла неожиданная ошибка
            </p>
          </div>
        </div>
        
        <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 mb-4">
          <p className="text-sm text-gray-600 dark:text-gray-300 font-mono break-words">
            {error.message}
          </p>
          {error.stack && (
            <details className="mt-2">
              <summary className="text-sm text-gray-500 cursor-pointer hover:text-gray-700">
                Подробности ошибки
              </summary>
              <pre className="text-xs text-gray-500 mt-2 overflow-auto max-h-32 whitespace-pre-wrap">
                {error.stack}
              </pre>
            </details>
          )}
        </div>
        
        <div className="flex space-x-3">
          <button
            onClick={resetErrorBoundary}
            className="flex-1 bg-primary-500 hover:bg-primary-600 text-white px-4 py-2 rounded-lg transition-colors"
          >
            🔄 Попробовать снова
          </button>
          <button
            onClick={() => window.location.reload()}
            className="flex-1 bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors"
          >
            🔄 Перезагрузить страницу
          </button>
        </div>
        
        <div className="mt-4 text-center">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Если проблема повторяется, проверьте:
          </p>
          <ul className="text-xs text-gray-400 dark:text-gray-500 mt-1 space-y-1">
            <li>• Backend сервер запущен (localhost:8000)</li>
            <li>• Соединение с интернетом</li>
            <li>• Консоль разработчика (F12)</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;